exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deflist{margin-top:10px}.deflist dt{float:left;clear:left}.deflist dd{margin-left:160px}", ""]);

// exports
